import React, { useState, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import styles from './Gallery.module.css';

const Gallery = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const images = [
    {
      id: 1,
      url: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
      title: 'Luxury Massage Room'
    },
    {
      id: 2,
      url: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
      title: 'Relaxing Spa Environment'
    },
    {
      id: 3,
      url: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
      title: 'Aromatherapy Setup'
    },
    {
      id: 4,
      url: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
      title: 'Peaceful Ambiance'
    },
    {
      id: 5,
      url: 'https://images.unsplash.com/photo-1596178065887-1198b6148b2b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
      title: 'Premium Spa Facilities'
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    const section = document.querySelector(`.${styles.gallery}`);
    if (section) observer.observe(section);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [images.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className={styles.gallery}>
      <div className={styles.container}>
        <div className={`${styles.sectionHeader} ${isVisible ? styles.fadeIn : ''}`}>
          <h2 className={styles.title}>Our Spa Gallery</h2>
          <p className={styles.subtitle}>Step into our world of luxury and tranquility</p>
        </div>

        <div className={`${styles.sliderContainer} ${isVisible ? styles.slideUp : ''}`}>
          <div className={styles.slider}>
            <div 
              className={styles.slidesWrapper}
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {images.map((image, index) => (
                <div key={image.id} className={styles.slide}>
                  <div className={styles.imageContainer}>
                    <img 
                      src={image.url} 
                      alt={image.title}
                      className={styles.slideImage}
                    />
                    <div className={styles.imageOverlay}>
                      <h3 className={styles.imageTitle}>{image.title}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button 
              className={`${styles.navButton} ${styles.prevButton}`}
              onClick={prevSlide}
              aria-label="Previous image"
            >
              <FaChevronLeft />
            </button>

            <button 
              className={`${styles.navButton} ${styles.nextButton}`}
              onClick={nextSlide}
              aria-label="Next image"
            >
              <FaChevronRight />
            </button>
          </div>

          <div className={styles.indicators}>
            {images.map((_, index) => (
              <button
                key={index}
                className={`${styles.indicator} ${index === currentSlide ? styles.active : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;